import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';
import BrIcons from '@components/BrIcons';
import './brInputBox.scss';

export default class BrInputBox extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.element,
    readOnly: PropTypes.bool,
    isDisabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    clickable: PropTypes.bool,
    clearable: PropTypes.bool,
    onEnter: PropTypes.func, // fire when enter is clicked
    onClick: PropTypes.func, // fire when icon is clicked, or when input box is clicked (if clickable=true)
    onInput: PropTypes.func, // onInput will return the pure text instead of event object
    onChange: PropTypes.func, // this will return event object, which will be triggered after onInput
    onKeyDown: PropTypes.func, // fire when key pressed
    onKeyPress: PropTypes.func, // fire when keycode registered (enter handled separately)
    onKeyUp: PropTypes.func, // fire when key released
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    autoFocus: false,
  };

  handleKeyPress = (e) => {
    const { onEnter } = this.props;
    if (e.key === 'Enter' && onEnter) {
      onEnter(e.target.value);
      return;
    }

    const { onKeyPress } = this.props;
    if (onKeyPress) {
      onKeyPress(e);
    }
  };

  handleClearInput = (e) => {
    e.stopPropagation();
    const { onInput, onEnter } = this.props;

    if (onInput) {
      onInput('');
    }
    if (onEnter) {
      onEnter('');
    }
  };

  handleOnInput = (e) => {
    const { onInput } = this.props;
    if (onInput) {
      onInput(e.target.value);
    }
  };

  handleOnChange = (e) => {
    // adding this intermittant function to ensure there's always onChange function passed to input dom
    // as react will set the dom to readOnly if value passed w/o onChange function passed
    const { onChange } = this.props;
    if (onChange) {
      onChange(e);
    }
  };

  handleOnIconClick = () => {
    const { onClick, value } = this.props;
    if (onClick) {
      onClick(value);
    }
  };

  render() {
    const {
      name,
      className,
      placeholder,
      value,
      readOnly,
      isDisabled,
      icon,
      clickable,
      clearable,
      onKeyDown,
      onKeyUp,
      onFocus,
      onBlur,
      autoFocus,
    } = this.props;
    const classname = cn('br-input-box', className, {
      disabled: readOnly,
      clickable,
    });
    return (
      <div className={classname} data-id="br-input-box">
        <input
          type="text"
          name={name}
          placeholder={placeholder}
          value={value}
          readOnly={readOnly}
          disabled={isDisabled}
          onInput={this.handleOnInput}
          onChange={this.handleOnChange}
          onKeyDown={onKeyDown}
          onKeyPress={this.handleKeyPress}
          onKeyUp={onKeyUp}
          onFocus={onFocus}
          onBlur={onBlur}
          autoFocus={autoFocus}
        />
        {clearable && (
          <i is="custom" onClick={this.handleClearInput}>
            <BrIcons.Clear isSubComp />
          </i>
        )}
        {icon && (
          <i is="custom" onClick={this.handleOnIconClick}>
            {icon}
          </i>
        )}
      </div>
    );
  }
}
